import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useGetFleetsQuery, useResetToPhoneAuthMutation } from '../../../../api/fleet-verification';
import { getApplicantIdFromAuthToken } from '../../../../general/utils/auth-token';
import { FLEET_SELECTION } from '../../../../paths';

const useVerifyAnotherCompany = () => {
  const [resetToPhoneAuth, { isSuccess: tokenReset }] = useResetToPhoneAuthMutation();
  const navigate = useNavigate();

  const needsTokenReset = getApplicantIdFromAuthToken() !== null;

  useEffect(() => {
    if (needsTokenReset) {
      void resetToPhoneAuth();
    }
  }, [needsTokenReset, resetToPhoneAuth]);

  const canFetch = !needsTokenReset || tokenReset;

  const { data: fleets, isFetching } = useGetFleetsQuery(undefined, {
    skip: !canFetch,
    refetchOnMountOrArgChange: true,
  });

  const showVerifyAnotherButton = canFetch && !isFetching && (fleets?.length ?? 0) >= 2;

  const handleVerifyAnotherClick = useCallback(() => {
    navigate(FLEET_SELECTION);
  }, [navigate]);

  return { showVerifyAnotherButton, handleVerifyAnotherClick };
};

export { useVerifyAnotherCompany };
